<script>
import Alert from '../../../slds/Alert'
import Card from '../../../slds/Card'
import Input from '../../../slds/Input'
import OutputField from '../../../slds/OutputField'
import Picklist from '../../../slds/Picklist'
import { validate } from '../../../utils/utils'

export default {
  components: {
    Alert,
    Card,
    Input,
    OutputField,
    Picklist
  },
  props: {
    editable: Boolean,
    engagementConditions: Array,
    engagementOptions: Array,
    isInformativeCampaign: Boolean,
    maintenanceModelCluster: Array,
    maintenanceModelClusterOptions: Array,
    mileageTag: String,
    mileageTagOptions: Array,
    monthsFromFirstRegistrationDate: String,
    showFilters: Boolean,
    validation: Array
  },
  data () {
    return {
      showMissingFilterError: false,
      disableMonthsFromFirstRegistrationDateField: false,
      canEditMMAAndTag: false,
      isMileageTagPicklistDisabled: false,
      localEngagementConditions: [],
      localMaintenanceModelCluster: [],
      localMileageTag: '',
      localMonthsFromFirstRegistrationDate: 0,
      yesNoOptions: [
        {
          label: this.$t('general.yes'),
          value: 'Y'
        },
        {
          label: this.$t('general.no'),
          value: 'N'
        }
      ]
    }
  },
  created () {
    this.localEngagementConditions = this.engagementConditions
    this.localMaintenanceModelCluster = this.maintenanceModelCluster
    this.localMileageTag = this.mileageTag
    this.localMonthsFromFirstRegistrationDate = this.monthsFromFirstRegistrationDate

    this.checkMileageTagDisabled(this.localEngagementConditions)

    if (this.showFilters && this.localEngagementConditions.length === 0) {
      this.addCondition()
    }
  },
  methods: {
    addCondition () {
      this.localEngagementConditions.push({
        mmaAvailable: '',
        lastUpdateDateIsLastWSVisit: '',
        mileageTagAvailable: '',
        engagementIndex: '',
        workshopVisitsWithSameMileageTagNumber: '',
        elapsedTimeBetweenLastTwoVisits: ''
      })
    },
    checkMileageTagDisabled (conditions) {
      this.isMileageTagPicklistDisabled = !!(conditions.length) && conditions.some(condition => condition.mileageTagAvailable === 'N')
    },
    canAddCondition (index) {
      if (index !== this.localEngagementConditions.length - 1) {
        return false
      } else {
        const lastRow = this.localEngagementConditions[this.localEngagementConditions.length - 1]
        return this.isRowComplete(lastRow)
      }
    },
    deleteCondition (index) {
      this.localEngagementConditions.splice(index, 1)
    },
    isRowComplete (row) {
      return Object.values(row).some(i => !!i)
    },
    setDefaultEngagementsRow () {
      this.localEngagementConditions = [
        {
          elapsedTimeBetweenLastTwoVisits: '',
          engagementIndex: '',
          lastUpdateDateIsLastWSVisit: '',
          mileageTagAvailable: '',
          mmaAvailable: '',
          workshopVisitsWithSameMileageTagNumber: ''
        }
      ]
      this.canEditMMAAndTag = true
    },
    validate () {
      this.showMissingFilterError = false

      const userAppliedAtLeastOneField = this.localEngagementConditions.some(condition => condition.mileageTagAvailable === 'Y' || condition.mmaAvailable === 'Y') || this.localMonthsFromFirstRegistrationDate
      if (!userAppliedAtLeastOneField) {
        this.showMissingFilterError = true
      } else {
        this.showMissingFilterError = false
      }
      return userAppliedAtLeastOneField && validate(this, 'cp_')
    }
  },
  watch: {
    engagementConditions (engagementConditions) {
      this.localEngagementConditions = engagementConditions
    },
    maintenanceModelCluster (maintenanceModelCluster) {
      this.localMaintenanceModelCluster = maintenanceModelCluster
    },
    mileageTag (mileageTag) {
      this.localMileageTag = mileageTag
    },
    monthsFromFirstRegistrationDate (monthsFromFirstRegistrationDate) {
      this.showMissingFilterError = false
      this.localMonthsFromFirstRegistrationDate = monthsFromFirstRegistrationDate
    },
    localEngagementConditions: {
      handler (engagementConditions) {
        this.showMissingFilterError = false
        const isEveryRowFilled = this.localEngagementConditions.some(condition => condition.mileageTagAvailable === 'Y' || condition.mmaAvailable === 'Y')
        if (engagementConditions.length && !this.canEditMMAAndTag && isEveryRowFilled) {
          this.disableMonthsFromFirstRegistrationDateField = true
        } else {
          this.disableMonthsFromFirstRegistrationDateField = false
        }
        this.$emit('update', { field: 'engagementConditions', newValue: engagementConditions })
        this.checkMileageTagDisabled(engagementConditions)
      },
      deep: true
    },
    localMaintenanceModelCluster (maintenanceModelCluster) {
      this.$emit('update', { field: 'maintenanceModelCluster', newValue: maintenanceModelCluster })
    },
    localMileageTag (mileageTag) {
      this.$emit('update', { field: 'mileageTag', newValue: mileageTag })
    },
    localMonthsFromFirstRegistrationDate (monthsFromFirstRegistrationDate) {
      if (monthsFromFirstRegistrationDate) {
        // this.setDefaultEngagementsRow()
        this.canEditMMAAndTag = true
      } else {
        this.canEditMMAAndTag = false
        // this.localEngagementConditions = []
        // this.addCondition()
      }
      this.$emit('update', { field: 'monthsFromFirstRegistrationDate', newValue: monthsFromFirstRegistrationDate })
    },
    showFilters (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.addCondition()
      } else if (!newValue && oldValue) {
        this.localEngagementConditions = []
      }
    }
  }
}
</script>

<template>
  <Card additional-classes="slds-card_boundary" :title="$t('campaignDesigner.targetDefinition.contactPlan')">
    <template #actions>
      <button class="slds-button slds-button_neutral" v-if="!isInformativeCampaign && editable" @click="$emit('apply-to-other-sections-cp')">
        {{$t('campaignDesigner.targetDefinition.applyToOtherSections')}}
      </button>
    </template>
    <!-- Alert section -->
    <alert type="error" :message="$t('validation.custom.atLeastOneFilterIsRequired')" v-if="showMissingFilterError" />

    <!-- Card -->
    <Card
      :title="$t('campaignDesigner.targetDefinition.cpTypeTargetSelection')"
      additional-classes="slds-card_boundary container" v-if="showFilters"
      class="slds-m-top--medium">
      <transition-group name="slide-fade-down">
        <template v-for="(condition, index) in localEngagementConditions">
          <div class="row slds-m-top--medium" :key="index" v-if="editable || isRowComplete(condition)">
            <!-- MMA Available -->
            <div>
              <Picklist
                :disabled="canEditMMAAndTag"
                :label="$t('campaignDesigner.targetDefinition.mmaAvailable')"
                :no-label="index > 0"
                :options="yesNoOptions"
                show-empty-value
                small
                v-if="editable"
                v-model="condition.mmaAvailable" />
              <OutputField
                :label="$t('campaignDesigner.targetDefinition.mmaAvailable')"
                :options="yesNoOptions"
                :value="condition.mmaAvailable"
                type="picklist"
                v-else/>
            </div>
            <!-- Updates from the last Workshop -->
            <div>
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.lastUpdateDateIsLastWSVisit.label')"
                :tooltip="$t('campaignDesigner.targetDefinition.lastUpdateDateIsLastWSVisit.tooltip')"
                :options="yesNoOptions"
                class="slds-m-left--small"
                show-empty-value
                small
                v-if="editable"
                v-model="condition.lastUpdateDateIsLastWSVisit" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.lastUpdateDateIsLastWSVisit.label')"
                :options="yesNoOptions"
                :tooltip="$t('campaignDesigner.targetDefinition.lastUpdateDateIsLastWSVisit.tooltip')"
                :value="condition.lastUpdateDateIsLastWSVisit"
                type="picklist"
                v-else/>
            </div>
            <!-- Mileage TAG Available -->
            <div>
              <Picklist
                :disabled="canEditMMAAndTag"
                :label="$t('campaignDesigner.targetDefinition.mileageTagAvailable')"
                :options="yesNoOptions"
                class="slds-m-left--small"
                show-empty-value
                small
                v-if="editable"
                v-model="condition.mileageTagAvailable" />

              <OutputField
                :label="$t('campaignDesigner.targetDefinition.mileageTagAvailable')"
                :options="yesNoOptions"
                :value="condition.mileageTagAvailable"
                type="picklist"
                v-else/>
            </div>
            <!-- Email Engagement Index -->
            <div>
              <Picklist
                :label="$t('campaignDesigner.targetDefinition.engagementIndex')"
                :options="engagementOptions"
                class="slds-m-left--small"
                labels-prefix="campaignDesigner.targetDefinition.engagement"
                show-empty-value
                small
                v-if="editable"
                v-model="condition.engagementIndex" />
              <OutputField
                :label="$t('campaignDesigner.targetDefinition.engagementIndex')"
                :options="engagementOptions"
                :value="condition.engagementIndex"
                labels-prefix="campaignDesigner.targetDefinition.engagement"
                type="picklist"
                v-else/>
            </div>
            <!-- Associated Mileage tag confirmed -->
            <!-- <div>
              <Picklist
                class="slds-m-left--small"
                :label="$t('campaignDesigner.targetDefinition.workshopVisitsWithSameMileageTagNumber.label')"
                :tooltip="$t('campaignDesigner.targetDefinition.workshopVisitsWithSameMileageTagNumber.tooltip')"
                :options="yesNoOptions"
                show-empty-value
                small
                v-if="editable"
                v-model="condition.workshopVisitsWithSameMileageTagNumber" />
              <OutputField
                :label="$t('campaignDesigner.targetDefinition.workshopVisitsWithSameMileageTagNumber.label')"
                :options="yesNoOptions"
                :value="condition.workshopVisitsWithSameMileageTagNumber"
                type="picklist"
                v-else/>
            </div> -->
            <!-- Workshop visit Elapsed Time -->
            <!-- <div>
              <Picklist
                class="slds-m-left--small"
                :label="$t('campaignDesigner.targetDefinition.elapsedTimeBetweenLastTwoVisits.label')"
                :tooltip="$t('campaignDesigner.targetDefinition.elapsedTimeBetweenLastTwoVisits.tooltip')"
                :options="yesNoOptions"
                show-empty-value
                small
                v-if="editable"
                v-model="condition.elapsedTimeBetweenLastTwoVisits" />
              <OutputField
                :label="$t('campaignDesigner.targetDefinition.elapsedTimeBetweenLastTwoVisits.label')"
                :options="yesNoOptions"
                :value="condition.elapsedTimeBetweenLastTwoVisits"
                type="picklist"
                v-else/>
            </div> -->
            <!-- Actions -->
            <div class="slds-m-left--medium button-container">
              <button
                :disabled="!canAddCondition(index)"
                :title="$t('campaignDesigner.targetDefinition.addEngagementCondition')"
                class="slds-button slds-button_icon slds-is-selected slds-button_icon-border-filled"
                v-if="editable"
                @click="addCondition">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#add"></use>
                </svg>
                <span class="slds-assistive-text">{{ $t('general.add')}}</span>
              </button>
              <button
                :title="$t('action.delete')"
                :disabled="localEngagementConditions.length === 1"
                class="slds-button slds-button_icon slds-button_icon-border-filled delete-button"
                v-if="editable"
                @click="deleteCondition(index)">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../../../assets/symbols.svg#delete"></use>
                </svg>
              </button>
            </div>
          </div>
        </template>
      </transition-group>
    </Card>
    <Card
      additional-classes="slds-card_boundary slds-m-top_medium"
      :title="$t('campaignDesigner.targetDefinition.touchpointSelection')">

      <div class="container">
        <div class="row">
          <div>
            <Picklist
              :disabled="isMileageTagPicklistDisabled"
              :label="$t('campaignDesigner.targetDefinition.mileageTag.label')"
              :options="mileageTagOptions"
              labels-prefix="campaignDesigner.targetDefinition.mileageTag"
              show-empty-value
              small
              v-if="editable"
              v-model="localMileageTag" />
            <OutputField
              :label="$t('campaignDesigner.targetDefinition.mileageTag.label')"
              :options="mileageTagOptions"
              :value="localMileageTag"
              labels-prefix="campaignDesigner.targetDefinition.mileageTag"
              type="picklist"
              v-else />
          </div>
          <div class="slds-m-horizontal--medium">
            <Picklist
              :label="$t('campaignDesigner.targetDefinition.maintenanceModelCluster')"
              :options="maintenanceModelClusterOptions"
              multipicklist
              small
              v-if="editable"
              v-model="localMaintenanceModelCluster"/>
            <OutputField
              :label="$t('campaignDesigner.targetDefinition.maintenanceModelCluster')"
              :options="maintenanceModelClusterOptions"
              :value="localMaintenanceModelCluster"
              type="multipicklist"
              v-else/>
          </div>
          <div>
            <Input
              :disabled="disableMonthsFromFirstRegistrationDateField"
              :label="$t('campaignDesigner.targetDefinition.monthsFromFirstRegistrationDate')"
              :validation="['positive-number', { name: 'less-or-equal-than', param: 120 }]"
              ref="cp_monthsFromFirstRegistrationDate"
              type="number"
              v-if="editable"
              v-model="localMonthsFromFirstRegistrationDate"/>
            <OutputField
              :label="$t('campaignDesigner.targetDefinition.monthsFromFirstRegistrationDate')"
              :value="localMonthsFromFirstRegistrationDate"
              type="text"
              v-else/>
          </div>
        </div>
      </div>
    </Card>
  </Card>
</template>

<style scoped lang="scss">
  .row {
    display: flex;
    flex-direction: row;

    & > * {
      align-self: flex-end;
      flex-grow: 1;
    }
  }

  .button-container {
    display: flex;
    flex-direction: row;
  }

  .delete-button:not(:disabled) {
    color: #C23933;
  }
</style>
